import React, { useState, useEffect, useRef } from 'react';
import classes from './ActionBar.module.css'
import { NavLink } from "react-router-dom";
import { useSelector } from 'react-redux';
import { login } from '../../../../store/auth-actions';
import useClickOutside from '../../../../hooks/useClickOutside';
import useReplaceNumChar from '../../../../hooks/useReplaceNumChar'
import UserInfo from '../../../UI/UserInfo'
import UserProfile from '../../../lms-shared/UI/UserProfile';
import defaultAvatar from '../../../../assests/user-profile/default-avatar.png'
import { onKeyDown } from '../../../../service';


const ActionBar = ({ showActions = true }) => {
    let activeClassName = classes.Current;
    const texts = useSelector(state => state.translate.texts);
    const { user, isAuthenticated } = useSelector(state => state.auth);
    const [showUserInfo, setShowUserInfo] = useState(false)

    const numClass = useReplaceNumChar()

    const popupRef = useRef(null);
    useClickOutside(popupRef, () => {
        setShowUserInfo(false);
    });

    function showUserInfoFunc(e) {
        e.stopPropagation();
        setShowUserInfo((prevShowUserInfo) => !prevShowUserInfo)
    }

    return (
        <div className={classes.ActionBar}>
            {isAuthenticated ? <div className={classes.UserInfo} onClick={(e) => showUserInfoFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => showUserInfoFunc(e))}>
                <UserProfile width="105px"
                    image={user.profileImage ?
                        `${user.profileImage}` :
                        defaultAvatar}
                />
                <div className={classes.UserDetails}>
                    <div className={classes.OverFlowText}> {user.firstName} {user.lastName}</div>
                    {user?.class ? <div>{numClass(user.class)}'</div> : ''}
                    <div className={classes.OverFlowText}>{user.schoolName}</div>

                </div>
            </div>
                : <div className={classes.UserDetails} onClick={login} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, login)}>{texts.headerLogin}</div>}
            {showActions && <>
                <NavLink className={({ isActive }) => isActive ? `${activeClassName}` : classes.Link} to={"dashboard"}>
                    <div className={classes.NavLinkItem}>
                        <div className={`${classes.IconList}  ${classes.IconDashboard}`}></div>
                        <h3 className={classes.IconText}>{texts.actionBarDashboard}</h3>
                    </div>
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? `${activeClassName}` : classes.Link} to={"assessments"}>
                    <div className={classes.NavLinkItem}>
                        <div className={`${classes.IconList}  ${classes.IconAssessments}`}></div>
                        <h3 className={classes.IconText}>{texts.actionBarAssessments}</h3>
                    </div>
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? `${activeClassName}` : classes.Link} to={"projects"}>
                    <div className={classes.NavLinkItem}>
                        <div className={`${classes.IconList}  ${classes.IconProjects}`}></div>
                        <h3 className={classes.IconText}>{texts.projects}</h3>
                    </div>
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? `${activeClassName}` : classes.Link} to={"friends"}>
                    <div className={classes.NavLinkItem}>
                        <div className={`${classes.IconList}  ${classes.IconFriends}`}></div>
                        <h3 className={classes.IconText}>{texts.actionBarFriends}</h3>
                    </div>
                </NavLink>
                <NavLink className={({ isActive }) => isActive ? `${activeClassName}` : classes.Link} to={"reports"}>
                    <div className={classes.NavLinkItem}>
                        <div className={`${classes.IconList}  ${classes.IconReports}`}></div>
                        <h3 className={classes.IconText}>{texts.actionBarReports}</h3>
                    </div>
                </NavLink>
            </>}

            {showUserInfo && <div className={classes.Popup} ref={popupRef}>
                <UserInfo />
            </div>}
        </div>
    )
}
export default ActionBar